import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';


import { useResponsive } from 'src/hooks/use-responsive';

import { bgGradient, textGradient } from 'src/theme/css';

import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function HomeCheckList() {
  const theme = useTheme();

  const mdUp = useResponsive('up', 'md');

  const renderDescription = (
    <Box sx={{ textAlign: { xs: 'center', md: 'unset' } }}>
      <m.div variants={varFade().inUp}>
        <Typography
          component="div"
          variant="overline"
          sx={{ color: 'primary.main', letterSpacing: 1.2, mb: 2 }}
        >
          Skill Tracking
        </Typography>
        <Typography
          variant="h2"
          sx={{
            mb: 3,
            ...textGradient(
              `300deg, ${theme.palette.primary.main} 0%, ${theme.palette.warning.main} 100%`
            ),
          }}
        >
          Track every skill, <br /> topic by topic
        </Typography>
        <Typography sx={{ color: 'text.secondary', maxWidth: 420, mx: { xs: 'auto', md: 0 } }}>
          Break skills into topics and subtopics, attach resources, and watch completion climb.
        </Typography>
      </m.div>
    </Box>
  );

  const renderImg = (
    <Box sx={{ perspective: '2400px' }}>
      <Box
        sx={{
          overflow: 'hidden',
          borderRadius: 2.5,
          bgcolor: 'background.paper',
          transformStyle: 'preserve-3d',
          transformOrigin: 'center',
          transform: { md: 'rotateY(-12deg) rotate(1.5deg)' },
          border: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
          boxShadow: `-40px 50px 100px -20px ${alpha(theme.palette.grey[600], 0.3)}`,
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.complex,
          }),
          '&:hover': { transform: { md: 'rotateY(0deg) rotate(0deg)' } },
        }}
      >
        <Box
          sx={{
            px: 2,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            borderBottom: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
            bgcolor: alpha(theme.palette.grey[500], 0.06),
          }}
        >
          {['#FF5F57', '#FEBC2E', '#28C840'].map((c) => (
            <Box key={c} sx={{ width: 11, height: 11, borderRadius: '50%', bgcolor: c }} />
          ))}
        </Box>
        <Box
          component="img"
          src="/assets/images/home/skills.png"
          alt="Track skills topic by topic"
          sx={{ display: 'block', width: 1, objectFit: 'cover' }}
        />
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        overflow: 'hidden',
        position: 'relative',
        py: { xs: 10, md: 15 },
        ...(mdUp && {
          ...bgGradient({
            color: alpha(theme.palette.background.default, 0.8),
            imgUrl: '/assets/background/overlay_4.jpg',
          }),
        }),
      }}
    >
      <Container component={MotionViewport}>
        <Grid container spacing={5} alignItems="center">
          <Grid xs={12} md={5}>
            {renderDescription}
          </Grid>

          <Grid xs={12} md={7}>
            {renderImg}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
